import { makeActionCreator } from '../../../utilities'
import { ToastConstants } from './toast.constants'

export const showToast = makeActionCreator(ToastConstants.SHOW_TOAST, 'toast')
export const hideToast = makeActionCreator(ToastConstants.HIDE_TOAST)
export const resetToast = makeActionCreator(ToastConstants.RESET_TOAST)
